import { Editor } from '@tiptap/react'

import { I18nShape } from '../../../i18n/types.js'

import { VideoSize } from './index.js'

interface VideoActionType {
  label: (editor: Editor) => string
  action: (editor: Editor) => void
  isActive: (editor: Editor) => boolean
}

export const videoSizeOptionsGenerator = ({
  $t,
}: I18nShape): VideoActionType[] => [
  {
    label: () =>
      $t({
        defaultMessage: 'Best fit',
        id: 'FigureOpts.BestFit.Label',
      }),
    action: editor =>
      editor.commands.setVideoAttributes({
        size: VideoSize.BestFit,
      }),
    isActive: editor => editor.isActive('video', { size: VideoSize.BestFit }),
  },
  {
    label: () =>
      $t({
        defaultMessage: 'Original size',
        id: 'FigureOpts.OriginalSize.Label',
      }),
    action: editor =>
      editor.commands.setVideoAttributes({
        size: VideoSize.Original,
      }),
    isActive: editor =>
      !editor.getAttributes('video')?.size ||
      editor.isActive('video', { size: VideoSize.Original }),
  },
]

export const getVideoSizeClassName = (size: VideoSize) => {
  switch (size) {
    case VideoSize.BestFit:
      /**
       * Some videos could be very long and cause layout issues (e.g. user has to scroll to see other content).
       * setting max-height to make sure by default the videos have a consistent layout.
       */
      return '[&_video]:max-h-[clamp(0rem,35dvh,26rem)] sm:[&_video]:max-h-[clamp(0rem,40dvh,32rem)]'
    case VideoSize.Original:
      return ''
    default: {
      const _exhaustiveCheck: never = size
      return _exhaustiveCheck
    }
  }
}
